import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { useGlobal } from "reactn";
import Credits from "./components/Credits";
import Logo from "./components/Logo";
import Input from "./components/Input";
import "./Login.sass";
import Div100vh from "react-div-100vh";
import Config from "../../config";
import loginV2 from "../../actions/login";
import { login } from "./../../reducers/auth/actions";
import { setConfig } from "./../../reducers/config/actions";
import register from "../../actions/register";
import { useHistory } from "react-router-dom";
import jwtDecode from "jwt-decode";
import setAuthToken from "../../actions/setAuthToken";
import { useDispatch } from "react-redux";
import initIO from "../../actions/initIO";
import loginImg from "../../img/login_mes.png";
import {
  getUserProfile,
  saveUserDataToLocalStorage,
  getSelectedBoardAndGradeFromLocal,
} from "../../services/dataServices/userProfileService";
import {
  getUserContentIfAvailable,
  saveSubjectDataToLocalStorage,
  saveFeedRailDataToLocalStorage,
  getLRSContent,
  saveLRSSyncDataToLocalStorage,
} from "../../services/dataServices/userContentService";
import { withTranslation } from "react-i18next";
import { secureStorage, spayeeJWT, getEncodedJWTToken } from "services/utility";
import { propTypes } from "react-tinder-card";
import {
  SuperAdminLogindata,
  TeacherLogindata,
  PrincipalLogindata,
} from "./userData";

const Login = (props) => {
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [keep, setKeep] = useState(true);
  const [loginErrors, setLoginErrors] = useState({});
  const [registerUsername, setRegisterUsername] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerFirstName, setRegisterFirstName] = useState("");
  const [registerLastName, setRegisterLastName] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [registerRepeatPassword, setRegisterRepeatPassword] = useState("");
  const [registerErrors, setRegisterErrors] = useState({});
  const [loader, setLoader] = useState(false);
  const [isStudent, setIsStudent] = useState(false);


  const setToken = useGlobal("token")[1];
  const setUser = useGlobal("user")[1];
  const [entryPath, setEntryPath] = useGlobal("entryPath");

  const history = useHistory();

  // async function loginFromStepApp(evt) {
  //   var token;
  //   if (
  //     evt.origin !== Config.url &&
  //     evt.origin !== "http://localhost:4000" &&
  //     evt.origin !== "http://localhost:3000"
  //   ) {
  //     console.log("here if: ", evt.origin);
  //     token = "here You are not worthy. request not from step app domain";
  //   } else {
  //     //console.log("here token: ", evt.data.jwt)
  //     token = evt.data.jwt;
  //     if (evt.data.jwt) {
  //       console.log("here JWT: ", token);
  //       // console.log("In padhao application ---->", token);
  //       if (keep) localStorage.setItem("token", token);
  //       if (keep)
  //         localStorage.setItem("user", JSON.stringify(jwtDecode(token)));
  //       setLoginErrors({});
  //       setAuthToken(token);
  //       setUser(jwtDecode(token));
  //       setToken(token);
  //       dispatch(initIO(token));
  //       history.replace(
  //         ["/login-padhao", "/"].includes(entryPath) ? "/" : entryPath
  //       );
  //       await setEntryPath(null);
  //     }
  //   }
  // }

  // if (window.addEventListener) {
  //   window.addEventListener("message", loginFromStepApp, false);
  // } else {
  //   // For IE
  //   window.attachEvent("onmessage", loginFromStepApp);
  // }



  useEffect(() => {
    console.log(TeacherLogindata, SuperAdminLogindata);
    
    console.log(props);
  }, []);

  const onLogin = async (e) => {
    e.preventDefault();
    setLoader(true);
    try {
      const res = await loginV2(email, password);
      await saveUserDataToLocalStorage(res.data);
      const token = res.headers.token;
      // if (keep) localStorage.setItem("token", token);

      secureStorage.setItem("token", token);

      // let testToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX21vYmlsZSI6Ijk2ODk0MjIzMzQiLCJjb3VudHJ5X2NvZGUiOiI5MSIsImJvYXJkX25hbWUiOiJTU0MiLCJsYW5nX3ByZWYiOiJlbiIsImdyYWRlX25hbWUiOiIxMCIsImlhdCI6MTYwNDQwNzg2MX0.vO2yS36cF_jpmmzXvWJiXZYF7yYJs6RcDs8RuCYbTmc'
      // if (keep) localStorage.setItem("user", JSON.stringify(jwtDecode(token)));
      // if (keep) localStorage.setItem('user', JSON.stringify(jwtDecode(testToken)));
      setLoginErrors({});
      setAuthToken(token);
      console.log(jwtDecode(token));
      console.log("MOBILE NUMBER:", jwtDecode(token).user_mobile);
      console.log(typeof jwtDecode(token).user_mobile);
      // if (jwtDecode(token).user_mobile === "9713012989") {
      //   console.log(res.data);
      //   console.log(SuperAdminLogindata);
      //   var Logindata = SuperAdminLogindata
      //   await saveUserDataToLocalStorage(Logindata);
      //   const token = getEncodedJWTToken(Logindata);
      //   // if (keep) localStorage.setItem("token", token);

      //   secureStorage.setItem("token", token);

      //   // let testToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX21vYmlsZSI6Ijk2ODk0MjIzMzQiLCJjb3VudHJ5X2NvZGUiOiI5MSIsImJvYXJkX25hbWUiOiJTU0MiLCJsYW5nX3ByZWYiOiJlbiIsImdyYWRlX25hbWUiOiIxMCIsImlhdCI6MTYwNDQwNzg2MX0.vO2yS36cF_jpmmzXvWJiXZYF7yYJs6RcDs8RuCYbTmc'
      //   // if (keep) localStorage.setItem("user", JSON.stringify(jwtDecode(token)));
      //   // if (keep) localStorage.setItem('user', JSON.stringify(jwtDecode(testToken)));
      //   setLoginErrors({});
      //   setAuthToken(token);
      //   console.log(jwtDecode(token));
      //   await setUser(Logindata);
      //   let user_mobile = Logindata.user_mobile;
      //   let school_id = Logindata.school_id;
      //   let country_code = Logindata.country_code;
      //   let userType = Logindata.user_type;
      //   // let userType = 'superadmin';
      //   let username = Logindata.username;
      //   let user_email = Logindata.user_email;
      //   let spayeeJWTtoken = spayeeJWT(username, user_email, password);
      //   // console.log("spayeeJWTtoken ",spayeeJWTtoken);
      //   secureStorage.setItem("spayeeJWTtoken", spayeeJWTtoken);
      //   await getUserProfile(user_mobile, school_id, country_code);
      //   setToken(token);
      //   dispatch(initIO(token));
      //   let newObj = { ...res.data, user_type: 'superadmin' }
      //   localStorage.setItem('user_type','superadmin')
      //   console.log(newObj);
      //   dispatch(login({ user: newObj }));
      //   if (userType === "student") {
      //     history.replace("/concepts");
      //   } else {
      //     history.replace("/home");
      //   }
      //   // history.push( "/");
      //   await setEntryPath(null);
      // } else if (jwtDecode(token).user_mobile === "77710030149999") {
      //   var Logindata = PrincipalLogindata
      //   // var Logindata = TeacherLogindata
      //   await saveUserDataToLocalStorage(Logindata);
      //   const token = getEncodedJWTToken(Logindata);
      //   console.log(token);
      //   secureStorage.setItem("token", token);
      //   setLoginErrors({});
      //   setAuthToken(token);
      //   await setUser(Logindata);
      //   let user_mobile = Logindata.user_mobile;
      //   let school_id = Logindata.school_id;
      //   let country_code = Logindata.country_code;
      //   let userType = Logindata.user_type;
      //   let username = Logindata.username;
      //   let user_email = Logindata.user_email;
      //   let spayeeJWTtoken = spayeeJWT(username, user_email, password);
      //   secureStorage.setItem("spayeeJWTtoken", spayeeJWTtoken);
      //   await getUserProfile(user_mobile, school_id, country_code);
      //   setToken(token);
      //   dispatch(initIO(token));
      //   // localStorage.setItem('user_type','teacher')
      //   // let newObj = {...res.data,user_type:'principal'}
      //   // dispatch(login({ user: newObj }));

      //   if (userType === "student") {
      //     history.replace("/concepts");
      //   } else {
      //     history.replace("/home");
      //   }
      //   await setEntryPath(null);
      // } else {
      await setUser(jwtDecode(token));
      let user_mobile = jwtDecode(token).user_mobile;
      let school_id = jwtDecode(token).school_id;
      let country_code = jwtDecode(token).country_code;
      let userType = jwtDecode(token).user_type;
      let username = jwtDecode(token).username;
      let user_email = jwtDecode(token).user_email;
      let spayeeJWTtoken = spayeeJWT(username, user_email, password);
      // console.log("spayeeJWTtoken ",spayeeJWTtoken);
      secureStorage.setItem("spayeeJWTtoken", spayeeJWTtoken);
      // await saveUserDataToLocalStorage(res)
      setToken(token);
      dispatch(initIO(token));
      dispatch(login(res.data));
      await apiCall(res.data);
      // if (userType === "student") {
      //   history.replace(
      //     ["/student/login", "/"].includes(entryPath) ? "/concepts" : entryPath
      //   );
      // } else {
      //   history.replace(
      //     ["/teacher/login", "/"].includes(entryPath) ? "/" : entryPath
      //   );
      // }

      // await getUserProfile(user_mobile, school_id, country_code)
      //   .then(() => {

      //   });
      setLoader(false);
      if (userType === "student") {
        history.replace("/concepts");
      } else {
        history.replace("/home");
      }
      // history.push( "/");
      setEntryPath(null);
      // }
    } catch (e) {
      setLoader(false);
      console.log("here Error: ", e);
      let errors = {};
      if (!e.response || typeof e.response.data !== "object")
        errors.generic = "Could not connect to server.";
      else errors = e.response.data;
      setLoginErrors(errors);
    }
  };



  const apiCall = async (user) => {
    localStorage.setItem(
      "I18N_LANGUAGE",
      user.lang_pref ? user.lang_pref : "en"
    );
    props.i18n.changeLanguage(user.lang_pref ? user.lang_pref : "en");
    // debugger;
    try {
      const userData = await getSelectedBoardAndGradeFromLocal();
      //console.log("userData", userData);
      if (userData) {
        const queryString =
          userData.selectedBoard +
          `&gradeId=` +
          userData.selectedGrade +
          `&schoolId=` +
          userData.selectedSchool +
          `&language=` +
          userData.selectedLanguage +
          `&platform=web`;

        //`${userData.selectedBoard}&gradeId=${userData.selectedGrade}&schoolId=${schoolListData[0].id}&language=${userData.selectedLanguage}`;
        //console.log("queryString", queryString);

        const subjectontentData = await getUserContentIfAvailable(queryString);
        //console.log("subjectontentData", subjectontentData);
        if (subjectontentData) {
          if (
            subjectontentData.content.subjects &&
            subjectontentData.content.subjects.length != 0
          ) {
            window.mainData = subjectontentData.content.subjects;
            //this.props.save(subjectontentData.content.subjects);
            saveSubjectDataToLocalStorage(subjectontentData.content.subjects);
            subjectontentData.feed.items.forEach((element, index) => {
              let indexObject = {
                index: index,
              };
              let newElement = Object.assign(element, indexObject);
              return newElement;
            });
            saveFeedRailDataToLocalStorage(subjectontentData.feed.items);
            //  const route = this.props.redirectUrl || "/";
            //  this.props.history.push(route);

            if (user.user_type === "student") {
              // this.props.history.replace(
              //   ["/login-otp", "/"].includes("entryPath")
              //     ? "entryPath"
              //     : "/concepts"
              // );
              props.history.replace("/concepts");
            } else {
              // this.props.history.replace(
              //   ["/login-otp", "/"].includes("entryPath") ? "/" : "entryPath"
              // );
              props.history.replace("/home");
            }

            dispatch(setConfig({ redirectUrl: "" }));
          } else {
            alert(props.t("onboarding.otp_login.no_grade_available"));
            props.history.push("/nocontent");
            //this.navigateToSelectGrade();
          }
        } else {
          alert(props.t("onboarding.otp_login.no_grade_available"));
          props.history.push("/nocontent");
          //this.navigateToSelectGrade();
        }
        const queryStringForLRS =
          `&user_id=` +
          userData.userId +
          `&board_name=` +
          userData.selectedBoard +
          `&grade_name=` +
          userData.selectedGrade;
        const lrsSyncData = await getLRSContent(queryStringForLRS);
        await saveLRSSyncDataToLocalStorage(lrsSyncData.data.body, true);
      }
    } catch (error) {
      // alert(error + ", Try again");
    }
  };

  const onRegister = async (e) => {
    e.preventDefault();
    try {
      await register({
        username: registerUsername,
        email: registerEmail,
        firstName: registerFirstName,
        lastName: registerLastName,
        password: registerPassword,
        repeatPassword: registerRepeatPassword,
      });
      const res = await loginV2(registerEmail, registerPassword);
      setRegisterErrors({});
      if (keep) localStorage.setItem("token", res.data.token);
      setAuthToken(res.data.token);
      setUser(jwtDecode(res.data.token));
      setToken(res.data.token);
      dispatch(initIO(res.data.token));
    } catch (e) {
      let errors = {};
      if (!e.response || typeof e.response.data !== "object")
        errors.generic = "Could not connect to server.";
      else errors = e.response.data;
      setRegisterErrors(errors);
    }
  };

  const loginInfo = Object.keys(loginErrors).map((key) => (
    <div className="uk-text-center" key={key}>
      <span className="uk-text-imp text-white">{loginErrors[key]}</span>
    </div>
  ));

  const registerInfo = Object.keys(registerErrors).map((key) => (
    <div className="uk-text-center" key={key}>
      <span className="uk-text-imp text-white">{registerErrors[key]}</span>
    </div>
  ));

  const switchLogin = () => {
    history.replace("/login-otp");
  };

  return (
    <>
    {
      props.isStudent ?


        // <Div100vh>
        //   <div className="login uk-cover-container uk-flex uk-flex-center uk-flex-middle uk-overflow-hidden uk-light">
        //     {/* <div className="uk-position-cover" /> */}
        //     <div className="login-scrollable uk-flex uk-flex-center uk-flex-middle uk-position-z-index">
        //       <Credits />
        //       <div className="login_message" style={{visibility : props.match.params.usertype==="teacher" ? "visible" : "hidden"}}>
        //         <img src={loginImg} />
        //       </div>
        //       <div
        //         className="login-inner uk-width-medium uk-padding-small"
        //         data-uk-scrollspy="cls: uk-animation-fade"
        //       >
        //         <Logo />
        <div className="toggle-credits">
          <form className="toggle-class" onSubmit={onLogin}>
            <fieldset className="uk-fieldset">
              {loginInfo}
              <Input
                icon="user"
                placeholder="Mobile Number"
                type="text"
                onChange={(e) => setEmail(e.target.value)}
              />
              <Input
                icon="lock"
                placeholder="Password"
                type="password"
                onChange={(e) => setPassword(e.target.value)}
              />
              {/* <div className="uk-margin-small">
                      <label>
                        <input
                          className="uk-checkbox"
                          type="checkbox"
                          onChange={(e) => setKeep(e.target.checked)}
                          checked={keep}
                        />{" "}
                        Keep me logged in
                      </label>
                    </div> */}
              {!loader ? (
                <div className="uk-margin-bottom">
                  <button
                    type="submit"
                    className="uk-button uk-button-primary uk-border-pill uk-width-1-1"
                  >
                    LOG IN
                  </button>
                  {/* <div className=" form-group text-center text-white mt-3">
                                          -{" "}
                                          {"OR"}
                                          -
                                        </div>
                        <button
                          type = "button"
                          className="uk-button uk-button-primary uk-border-pill uk-width-1-1 mt-2"
                          onClick ={switchLogin}
                        >
                          OTP Login
                        </button> */}
                </div>


              ) : (
                <div className="text-center card-button">
                  <Spinner
                    className=" "
                    animation="border"
                    style={{ color: "#fff" }}
                    size="md"
                  />
                </div>
              )}
            </fieldset>
          </form>

          <form className="toggle-class" onSubmit={onRegister} hidden>
            {registerInfo}
            <Input
              icon="user"
              placeholder="Username"
              type="text"
              onChange={(e) => setRegisterUsername(e.target.value)}
            />
            <Input
              icon="mail"
              placeholder="Email"
              type="email"
              onChange={(e) => setRegisterEmail(e.target.value)}
            />
            <Input
              icon="pencil"
              placeholder="First Name"
              type="text"
              onChange={(e) => setRegisterFirstName(e.target.value)}
            />
            <Input
              icon="pencil"
              placeholder="Last Name"
              type="text"
              onChange={(e) => setRegisterLastName(e.target.value)}
            />
            <Input
              icon="lock"
              placeholder="Password"
              type="password"
              onChange={(e) => setRegisterPassword(e.target.value)}
            />
            <Input
              icon="lock"
              placeholder="Repeat Password"
              type="password"
              onChange={(e) => setRegisterRepeatPassword(e.target.value)}
            />
            <div className="uk-margin-bottom">
              <button
                type="submit"
                className="uk-button uk-button-primary uk-border-pill uk-width-1-1"
              >
                REGISTER
              </button>
            </div>
          </form>

          <form className="toggle-password" hidden>
            <Input icon="mail" placeholder="Email" type="email" />
            <div className="uk-margin-bottom">
              <button
                type="submit"
                className="uk-button uk-button-primary uk-border-pill uk-width-1-1"
              >
                SEND CODE
              </button>
            </div>
          </form>

          <div>
            <div className="uk-text-center">
              {/* <span className="display_flex">
                      <a className="uk-link-reset uk-text-small toggle-class"
                                         data-uk-toggle="target: .toggle-class ;animation: uk-animation-fade">Forgot Password</a>
                                      <a className="uk-link-reset uk-text-small toggle-class"
                                         data-uk-toggle="target: .toggle-class ;animation: uk-animation-fade">Need an account?</a>
                    </span> */}
              <a
                className="uk-link-reset uk-text-small toggle-class"
                data-uk-toggle="target: .toggle-class ;animation: uk-animation-fade"
                hidden
              >
                <span data-uk-icon="arrow-left" /> Back to Login
              </a>
            </div>
          </div>
        </div>
        //       </div>
        //     </div>
        //   </div>
        // </Div100vh>
        :

        <Div100vh>
          <div className="login uk-cover-container uk-flex uk-flex-center uk-flex-middle uk-overflow-hidden uk-light">
            {/* <div className="uk-position-cover" /> */}
            <div className="login-scrollable uk-flex uk-flex-center uk-flex-middle uk-position-z-index">
              <Credits />
              <div className="login_message" style={{ visibility: props.match.params.usertype === "teacher" ? "visible" : "hidden" }}>
                <img src={loginImg} />
              </div>
              <div
                className="login-inner uk-width-medium uk-padding-small"
                data-uk-scrollspy="cls: uk-animation-fade"
              >
                <Logo />
                <div className="toggle-credits">
                  <form className="toggle-class" onSubmit={onLogin}>
                    <fieldset className="uk-fieldset">
                      {loginInfo}
                      <Input
                        icon="user"
                        placeholder="Mobile Number"
                        type="text"
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <Input
                        icon="lock"
                        placeholder="Password"
                        type="password"
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {/* <div className="uk-margin-small">
                <label>
                  <input
                    className="uk-checkbox"
                    type="checkbox"
                    onChange={(e) => setKeep(e.target.checked)}
                    checked={keep}
                  />{" "}
                  Keep me logged in
                </label>
              </div> */}
                      {!loader ? (
                        <div className="uk-margin-bottom">
                          <button
                            type="submit"
                            className="uk-button uk-button-primary uk-border-pill uk-width-1-1"
                          >
                            LOG IN
                          </button>
                          {/* <div className=" form-group text-center text-white mt-3">
                                    -{" "}
                                    {"OR"}
                                    -
                                  </div>
                  <button
                    type = "button"
                    className="uk-button uk-button-primary uk-border-pill uk-width-1-1 mt-2"
                    onClick ={switchLogin}
                  >
                    OTP Login
                  </button> */}
                        </div>


                      ) : (
                        <div className="text-center card-button">
                          <Spinner
                            className=" "
                            animation="border"
                            style={{ color: "#fff" }}
                            size="md"
                          />
                        </div>
                      )}
                    </fieldset>
                  </form>

                  <form className="toggle-class" onSubmit={onRegister} hidden>
                    {registerInfo}
                    <Input
                      icon="user"
                      placeholder="Username"
                      type="text"
                      onChange={(e) => setRegisterUsername(e.target.value)}
                    />
                    <Input
                      icon="mail"
                      placeholder="Email"
                      type="email"
                      onChange={(e) => setRegisterEmail(e.target.value)}
                    />
                    <Input
                      icon="pencil"
                      placeholder="First Name"
                      type="text"
                      onChange={(e) => setRegisterFirstName(e.target.value)}
                    />
                    <Input
                      icon="pencil"
                      placeholder="Last Name"
                      type="text"
                      onChange={(e) => setRegisterLastName(e.target.value)}
                    />
                    <Input
                      icon="lock"
                      placeholder="Password"
                      type="password"
                      onChange={(e) => setRegisterPassword(e.target.value)}
                    />
                    <Input
                      icon="lock"
                      placeholder="Repeat Password"
                      type="password"
                      onChange={(e) => setRegisterRepeatPassword(e.target.value)}
                    />
                    <div className="uk-margin-bottom">
                      <button
                        type="submit"
                        className="uk-button uk-button-primary uk-border-pill uk-width-1-1"
                      >
                        REGISTER
                      </button>
                    </div>
                  </form>

                  <form className="toggle-password" hidden>
                    <Input icon="mail" placeholder="Email" type="email" />
                    <div className="uk-margin-bottom">
                      <button
                        type="submit"
                        className="uk-button uk-button-primary uk-border-pill uk-width-1-1"
                      >
                        SEND CODE
                      </button>
                    </div>
                  </form>

                  <div>
                    <div className="uk-text-center">
                      {/* <span className="display_flex">
                <a className="uk-link-reset uk-text-small toggle-class"
                                  data-uk-toggle="target: .toggle-class ;animation: uk-animation-fade">Forgot Password</a>
                                <a className="uk-link-reset uk-text-small toggle-class"
                                  data-uk-toggle="target: .toggle-class ;animation: uk-animation-fade">Need an account?</a>
              </span> */}
                      <a
                        className="uk-link-reset uk-text-small toggle-class"
                        data-uk-toggle="target: .toggle-class ;animation: uk-animation-fade"
                        hidden
                      >
                        <span data-uk-icon="arrow-left" /> Back to Login
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Div100vh>
    }
    </>
  );
};

export default withTranslation()(Login);
